import { Aggregator, EnrollmentBankAccount } from 'src/state/dutchiePay-enrollment';
import { GqlShowEnrollmentQuery } from 'types/graphql';
import { BANK_DIGITS_MISSING, UNKNOWN_BANK } from '../constants';

export type BankDetailResponse = {
  bankName: string;
  lastDigits: string;
  bankLogo: string;
};

export const getBankDetails = (bank: EnrollmentBankAccount): BankDetailResponse => {
  const bankName = bank.bankName || UNKNOWN_BANK;
  const lastDigits = bank.lastDigits || BANK_DIGITS_MISSING;
  const bankLogo =
    'financialInstitutionLogo' in bank && !!bank.financialInstitutionLogo ? bank.financialInstitutionLogo : '';

  return {
    bankName,
    lastDigits,
    bankLogo,
  };
};

const isValidBankAccount = (
  acct: GqlShowEnrollmentQuery['showEnrollment']['paymentMethods'][0]
): acct is NonNullable<GqlShowEnrollmentQuery['showEnrollment']['paymentMethods'][0]> =>
  !!acct && acct.status === 'active';

export const mapBankAccounts = (
  bankAccounts: GqlShowEnrollmentQuery['showEnrollment']['paymentMethods']
): EnrollmentBankAccount[] =>
  bankAccounts.filter(isValidBankAccount).map((acct) => ({
    accountAlias: acct.bankAccountDetails.accountAlias,
    aggregator: acct.bankAccountDetails.aggregator as Aggregator,
    bankName: acct.bankAccountDetails.bankName,
    billingAddressId: acct.bankAccountDetails.billingAddressId ?? '',
    connectionStatus: acct.bankAccountDetails.status,
    id: acct.id,
    lastDigits: acct.bankAccountDetails.lastDigits,
    status: acct.status,
    financialInstitutionLogo: acct.bankAccountDetails.financialInstitutionLogo,
  }));
